import React, { useEffect, useState } from 'react';
import { FiX } from "react-icons/fi";
import { useSelector } from "react-redux";
import { formatPrice } from "../../util/format";
import { getExtractProductsCart } from "../../util/price";
import { PriceType } from "../../util/priceType";
import { Container, Discount, Item, ItemsList, Modal, ModalHeader } from './styles';
import { productImageSrc, handleProductImageError } from '../../util/imageFallback';

function CartItensModal(props) {
  const [open, setOpen] = useState(props.isOpen);

  const {
    data: basket,
  } = useSelector((state) => state.cart);
  const { programa_fidelidade = false } = useSelector((state) =>
    state.user.profile == null ? false : state.user.profile
  );

  const [promotions, setPromotions] = useState([]);

  useEffect(() => {
    const { promotions } = getExtractProductsCart(basket.itens, programa_fidelidade);
    setPromotions(promotions);
  }, [basket, programa_fidelidade]);

  useEffect(() => {
     setOpen(props.isOpen);
  }, [props.isOpen]);

  function handleClose() {
    props.handleClose();
  }

  return (
    <>
    {open && (
        <Container>
          <Modal>
            <ModalHeader>
              <div>
                <h1>Itens do pedido</h1>
              </div>
              <button onClick={handleClose}><FiX /></button>
            </ModalHeader>

            <div className="wrap" >
              <ItemsList>
                <h2>Minha cesta</h2>
                  {promotions.map((promotion) => (
                  <Item key={promotion.priceId}>
                    <div className="content-area">
                      <img
                        src={productImageSrc(promotion.product)}
                        onError={handleProductImageError(promotion.product)}
                        alt={promotion.product.nome}
                      />
                      <div className="text-area">
                        <strong>{promotion.product.nome}</strong>
                        <span>Qtde: {promotion.promotionQuantity}</span>
                        {promotion.type === PriceType.TAKEMOREPAYLESS && promotion.takeQuantity && promotion.payQuantity && (
                          <span>Leve {promotion.takeQuantity} pague {promotion.payQuantity}</span>
                        )}
                        {(promotion.priceOf !== promotion.priceBy) && (
                          <>
                            <span className="oldValue">De: {formatPrice(promotion.priceOf)}</span>
                            <span className="value">Por: {formatPrice(promotion.priceBy)}</span>
                          </>
                        )}
                        {(promotion.priceOf === promotion.priceBy) && (
                          <>
                            <span className="value">{formatPrice(promotion.priceBy)}</span>
                          </>
                        )}

                      </div>
                      {promotion.discount > 0 && (
                        <Discount>
                    <span>
                      {parseFloat(
                        promotion.discount * -1
                      ).toLocaleString("pt-BR")}
                      %
                    </span>
                    </Discount>
                )}
                    </div>
                  </Item>
                ))}

                {promotions.length === 0 && (
                  <span className="none-accepted">A cesta está vazia</span>
                )}
              </ItemsList>
            </div>
          </Modal>
        </Container>
         )}
    </>
  );
}

export default CartItensModal;
